
<template>
    <div class="error404">
        <errorItem :data="data">
            <img src="@/assets/images/licence_expiration.png">
        </errorItem>
    </div>
</template>

<script>
import errorItem from '@/views/components/basic/erroritem'
export default {
    name: 'license',
    data () {
        return {
            data: {
                ms: '抱歉，您的认证许可已过期…',
                ts: '请联系管理员更新密钥!'
            }
        }
    },
    components: { errorItem }
}
</script>
<style lang="less">
</style>
